export const entraConfig = {
  clientId: process.env.REACT_APP_ENTRA_CLIENT_ID || "",
  authority: process.env.REACT_APP_ENTRA_AUTHORITY || "",
  redirectUri: process.env.REACT_APP_REDIRECT_URI || "",
  postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || "",
  scopes: ["openid", "profile", "email", "User.Read"],
};
